"use client";
import { useQuery } from "@tanstack/react-query";

import apiSampleClient from "@/lib/apiSampleClient";

export default function RequestExamplePage() {
  const { data: responseJson } = useQuery({
    queryKey: [`request`],
    queryFn: async () => {
      const res = await apiSampleClient.api.v1.transactions[":id"].$get({
        param: {
          id: "e06d318b-7164-4a4d-98e2-8183a7381d71",
        },
      });

      return await res.json();
    },
  });

  return (
    <div>
      {responseJson?.success ? (
        <>
          Transaction price: {responseJson.data.price}
          <br />
          <br />
          <br />
          Success data: {JSON.stringify(responseJson)}
        </>
      ) : (
        <>
          Request failed! message: {responseJson?.error.message}
          <br />
          <br />
          <br />
          error data: {JSON.stringify(responseJson)}
        </>
      )}
    </div>
  );
}
